<div *ngIf="params.data && !params.data.editable">
    <input type="checkbox" [(ngModel)]="params.data.inactive" disabled >
</div>
<div *ngIf="params.data && params.data.editable">
    <input type="checkbox" [(ngModel)]="params.data.inactive">
</div>